import { createContext, useContext } from 'react'
import { styled } from '@mui/system'
import colors from 'common/colors'
import { TEST_IDS } from 'test-ids'

// Defaults to modal-internal.jsx's TEST_IDS.modalDialogTitle, which is what
// that Dialog's aria-labelledby points to once a header registers (see
// ModalHeaderRegistryContext below). A dialog that nests inside that one
// global modal (e.g. ChangeEmailDialog inside UserDetails) overrides this
// with its own useId() value so the two headers don't collide.
export const ModalHeaderIdContext = createContext(TEST_IDS.modalDialogTitle)

// Lets a ModalHeader tell the nearest ModalInternal that an accessible
// heading actually exists in the DOM, so that Dialog's aria-labelledby only
// ever points at an id something renders. Defaults to a no-op: ModalHeader
// instances that aren't inside a ModalInternal (e.g. ChangeEmailDialog, which
// wires its own Dialog's aria-labelledby directly) have nothing to report to.
export const ModalHeaderRegistryContext = createContext(null)

export default function ModalHeader(props) {
  const id = useContext(ModalHeaderIdContext)
  const registerHeader = useContext(ModalHeaderRegistryContext)

  useEffect(() => {
    registerHeader?.(1)
    return () => registerHeader?.(-1)
  }, [registerHeader])

  return <StyledHeader id={id}>{props.children}</StyledHeader>
}

const StyledHeader = styled('h1')({
  color: colors.brand,
  fontWeight: 700,
  fontSize: '22px',
  margin: '0 0 1em 0',
  paddingBottom: '0.5em',
  borderBottom: `1px solid ${colors.greyBorder}`,
  textAlign: 'center',
})
